'use strict';
/* @flow */

var variance = require('./variance');
/**
 * The [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
 * is the square root of the variance. It's useful for measuring the amount
 * of variation or dispersion in a set of values.
 *
 * Standard deviation is only appropriate for full-population knowledge: for
 * samples of a population, {@link sampleStandardDeviation} is
 * more appropriate.
 *
 * @param {Array<number>} x input
 * @returns {number} standard deviation
 * @example
 * variance([2, 4, 4, 4, 5, 5, 7, 9]); // => 4
 * standardDeviation([2, 4, 4, 4, 5, 5, 7, 9]); // => 2
 */


function standardDeviation(x
/*: Array<number> */
)
/*:number*/
{
  // The standard deviation of no numbers is null
  var v = variance(x);

  if (isNaN(v)) {
    return 0;
  }

  return Math.sqrt(v);
}

module.exports = standardDeviation;